import React from "react";

type Props = {
  className?: string;
};
export const CopyIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C5.44772 0 5 0.447715 5 1C5 1.55228 5.44772 2 6 2H6.5H12V9.5C12 10.0523 12.4477 10.5 13 10.5C13.5523 10.5 14 10.0523 14 9.5V2C14 0.895431 13.1046 0 12 0H6.5H6ZM2 13V5H9V13H2ZM1.5 3C0.671573 3 0 3.67157 0 4.5V13C0 14.1046 0.89543 15 2 15H9C10.1046 15 11 14.1046 11 13V5C11 3.89543 10.1046 3 9 3H1.5Z"
      />
    </svg>
  );
};
